import React, {  } from 'react';
import { mergeStyles, IStyle, DetailsListLayoutMode, SelectionMode, IDetailsListStyles, DetailsList, IColumn, Selection, IDetailsRowProps, DetailsRow } from '@fluentui/react';
import { BwjPaginator } from '../bwj-paginator';
import { BwjSemiFlexContainer } from '../bwj-semi-flex-container';

export interface IBwjTableStyles {
  root?: IStyle;// by default, flex column
  listContainer?: IStyle;//table container, semi flex container
}

export interface IBwjTableUiProps {
  items: any[];
  columns: IColumn[];
  selection: Selection | undefined;
  selectionMode: SelectionMode | undefined;
  getKey: (item: any, index?: number | undefined) => string;
  onItemInvoked: ((item?: any, index?: number | undefined, ev?: Event | undefined) => void) | undefined;
  numberOfPages: number | undefined;
  currentPageIndex: number | undefined;
  onPageChangeRequested?: (pageIndex: number) => void;
  onColumnClicked: (column: IColumn) => void;
  tableStyles: IBwjTableStyles | undefined;
  setRowBackgroundColor?: (item?: any, index?: number) => string | null | undefined;
  semiFlexWidth: boolean | undefined;
  semiFlexHeight: boolean | undefined;
  selectionPreservedOnEmptyClick: boolean | undefined;
  ariaLabelForSelectionColumn: string | undefined;
  ariaLabelForSelectAllCheckbox: string | undefined;
  checkButtonAriaLabel: string | undefined;
}

const rootStyleBase: IStyle = {
  display: 'flex',
  flexDirection: 'column',
};

const gridStyles: Partial<IDetailsListStyles> = {
  root: {
    height: '100%',
    selectors: {
      '& [role=grid]': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        height: '100%',
      },
    },
  },
  headerWrapper: {
    flex: '0 0 auto',
  },
  contentWrapper: {
    flex: '1 1 auto',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
};

const semiFlexHeightContainerStyle: IStyle = {
  '& .ms-Viewport': {
    height: '100%',
  },
};

export const BwjTableUi: React.FunctionComponent<IBwjTableUiProps> = (props) => {

  const { tableStyles, setRowBackgroundColor } = props;

  const rootClassName = (() => {
    const styles: IStyle[] = [rootStyleBase];
    !!tableStyles?.root && styles.push(tableStyles.root);
    return mergeStyles(styles);
  })();
  props.selection?.getSelection()

  const semiFlexClassName = (() => {
    const styles: IStyle[] = [];
    !!tableStyles?.listContainer && styles.push(tableStyles.listContainer);
    !!props.semiFlexHeight && styles.push(semiFlexHeightContainerStyle);

    return mergeStyles(styles);
  })();

  const onRenderRow = !!setRowBackgroundColor ? (rowProps?: IDetailsRowProps) => {
    if(!rowProps) { return null; }
    const defaultRow = (<DetailsRow {...rowProps} />);
    const backgroundColor = setRowBackgroundColor!(rowProps.item, rowProps.itemIndex);
    if(!backgroundColor) { return defaultRow; }

    const customStyles = { root: { backgroundColor } };
    return (<DetailsRow {...rowProps} styles={customStyles} />);
  } : undefined;

  return (
    <div className={rootClassName}>
      <BwjSemiFlexContainer
        pinHeight={props.semiFlexHeight}
        pinWidth={props.semiFlexWidth}
        styles={{ root: semiFlexClassName }}
      >
        <DetailsList
          items={props.items ?? []}
          compact={false}
          columns={props.columns}
          onColumnHeaderClick={(e, col) => !!col && props.onColumnClicked(col)}
          selectionMode={props.selectionMode ?? SelectionMode.none}
          getKey={props.getKey}
          layoutMode={DetailsListLayoutMode.fixedColumns}
          selection={props.selection}
          selectionPreservedOnEmptyClick={props.selectionPreservedOnEmptyClick}
          ariaLabelForSelectionColumn={props.ariaLabelForSelectionColumn}
          ariaLabelForSelectAllCheckbox={props.ariaLabelForSelectAllCheckbox}
          checkButtonAriaLabel={props.checkButtonAriaLabel}
          isHeaderVisible={true}
          onRenderRow={onRenderRow}
          onItemInvoked={props.onItemInvoked}
          styles={gridStyles}
        />
      </BwjSemiFlexContainer>
      
      {props.currentPageIndex !== undefined &&
      <BwjPaginator
        numberOfPages={!!props.numberOfPages && props.numberOfPages > 0 ? props.numberOfPages : 1}
        currentPageIndex={props.currentPageIndex ?? 0}
        onPageChangeRequested={!!props.onPageChangeRequested ? props.onPageChangeRequested : () => {}}
      />}
    </div>
  );
};
